<template>
  <div class="form-group" :class="formGroupClasses" style="position: relative">
    <label class="form-label" v-if="label" :for="id">{{ label }}</label>
    <div class="input-wrapper">
      <input class="input input--text" :class="stateClasses" :name="id" :type="type" :aria-labelledby="id" :id="id" v-model="currentValue" :disabled="disabled" :placeholder="placeholder" v-bind="$attrs" :maxlength="maxlength" :required="required" />
      <icon :name="iconName" />
      <span class="input__underline" aria-hidden="true" />
      <div v-if="!valid" class="input__error" role="alert">
        <slot name="error" />
      </div>
      <div class="input__info">
        <slot name="info" />
      </div>
    </div>
  </div>
</template>

<script>
  import Icon from '../basic/Icon.vue';

  export default {
    name: 'TextInput',
    components: {
      Icon,
    },
    props: {
      icon: String,
      value: [String, Number],
      label: String,
      maxlength: {
        type: String,
        required: false,
      },
      secondary: {
        type: Boolean,
        default: false,
      },
      placeholder: {
        type: String,
        default: '',
      },
      type: {
        type: String,
        default: 'text',
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      validator: {
        type: Function,
        default: () => true,
      },
      id: {
        type: String,
        required: true,
      },
      required: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        initialized: false,
        currentValue: this.value || '',
      };
    },
    computed: {
      formGroupClasses() {
        const disabled = this.disabled;

        return {
          'form-group--disabled': disabled,
        };
      },
      stateClasses() {
        const dirty = this.currentValue.length >= 1 && this.currentValue !== '';
        const disabled = this.disabled;
        const valid = this.valid;

        return {
          'input--dirty': dirty,
          'input--disabled': disabled,
          'input--valid': valid,
          'input--invalid': !valid,
          'input--secondary': this.secondary,
        };
      },
      valid() {
        const v = this.validator(this.currentValue);
        return v;
      },
      iconName() {
        if (this.icon) {
          return this.icon;
        }
        return '';
      },
    },
    watch: {
      currentValue(p, c) {
        this.$emit('input', this.currentValue);
      },
    },
    methods: {
      set(val) {
        this.currentValue = val;
      },
    },
  };
</script>

<style scoped lang="scss"></style>
